// eslint-disable-next-line import/prefer-default-export
export const NETWORK_URL = 'https://slot.tizeti.com/cnmaestro/Views/index.php';
